<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>
<script>
export default {
    name:"app",
    created:function() {
        this.getCurrentUser();
        //刷新、重新进入系统，重新获取用户信息
        // this.$axios.get("/user/getCurrentUser")
        // .then(res => {
        //     if (res.code === 200) {
        //         this.$store.commit('updateUserInfo', res.data);
        //     } else {
        //         this.$alert(res.errMsg, "错误提示")
        //         .then(data => {
        //             this.$router.replace("/login");
        //         });
        //     }
        // })
        // .catch(err => {});
    }
}
</script>

<style>
</style>